export default __webpack_public_path__ + "static/media/Logo.f3631a5b.svg";